import { Spin } from 'antd';
import { SpinProps } from 'antd/es/spin';

interface SpinnerProps {
  children: React.ReactNode;
  spinnerProps?: SpinProps;
}

export const Spinner = ({ children, spinnerProps }: SpinnerProps) => {

  return (
    <Spin {...spinnerProps}>
      {children}
    </Spin>
  );
};
